import { Component, Input } from '@angular/core';
import { SwitchUserService } from '@app/auth/switch-user.service';

/**
 * TVG-378: the strip at the top of every page while an admin is viewing as
 * someone else, with the one-click way back to their own session.
 */
@Component({
  selector: 'app-switch-user-banner',
  templateUrl: './switch-user-banner.component.html',
  standalone: true,
})
export class SwitchUserBannerComponent {
  @Input({ required: true }) viewingAsName = '';

  protected switchingBack = false;

  constructor(private switchUserService: SwitchUserService) {}

  protected switchBack(): void {
    if (this.switchingBack) {
      return;
    }
    this.switchingBack = true;
    this.switchUserService.switchBack().subscribe();
  }
}
